export default function QueryParams() {
  const url = new URLSearchParams(document.location.search.replace(/(^\?)/, ''))

  return Object.fromEntries(url.entries())
}
